/**
 * The platform ladder, as the console reads it.
 *
 * Its own module rather than a corner of `api.ts`, for the same reason
 * `summariseCaps` is not in `Overview.tsx`: `api.ts` imports `config.ts`, which
 * reads `import.meta.env`, which does not exist under `node --test`. Logic that
 * cannot be loaded by the runner is logic nothing can execute — and this
 * particular logic decides what a menu offers, which is where the fault it fixes
 * came from.
 *
 * A second copy of the worker's ladder in `lib/access.ts`, and the duplication
 * is deliberate rather than shared: the two packages ship in one
 * `wrangler deploy` but do not import from each other, and the alternative is a
 * shared package to hold four strings. What matters is that the order stays the
 * same — `roles.test.ts` reads `ROLES` out of the worker
 * source and asserts the whole matrix against it, so a rung added there and
 * forgotten here fails a test rather than quietly offering links the API
 * refuses.
 *
 * This never grants anything. Every governing route is refused server-side
 * against fbads' own tables, whatever the menu shows; this only decides what to
 * offer, so the console does not promise what the API will not deliver.
 */
export type Role = "super_admin" | "admin" | "manager" | "user";

const ROLE_RANK: Record<Role, number> = { user: 1, manager: 2, admin: 3, super_admin: 4 };

export function roleAtLeast(role: Role, floor: Role): boolean {
	return ROLE_RANK[role] >= ROLE_RANK[floor];
}
